import React, { useEffect } from 'react';
import { PhoneScreeningScheduler, useWebView } from '@mp';
import { Box } from '@medely/ui-kit';

const PhoneScreeningSchedulerEmbedded = () => {
  const { setIsWebView } = useWebView();

  useEffect(() => {
    setIsWebView(true);
  }, []);

  return (
    <Box p={1}>
      <PhoneScreeningScheduler />
    </Box>
  );
};

export default PhoneScreeningSchedulerEmbedded;
